import {useContext} from "react";
import {DrawerContext} from "./DrawerProvider.context";

export default function useDrawer() {
    return useContext(DrawerContext);
}
